angular.module('bmsApp.trugreen.schedule')
	.controller('TGScheduleCtrl',
		function ($state,
				  $scope,
				  $compile,
				  ConfigService,
				  DirectionSvc,
				  TGVisitSvc,
				  TGScheduleSvc,
				  TGRouteSvc,
				  ActivitySvc,
				  TGTreatmentSvc,
				  VisitPlannerSvc,
				  EmployeeSvc,
				  ManualRouteSvc,
				  $mdDialog,
				  CalendarSvc,
				  $window,
				  notify,
				  $timeout,
				  $q,
				  uiCalendarConfig,
				  ProximitySvc,
					EmployeeHolidaySvc) {


			function init() {
				setDefaultEventView();

				// select the current day
				if ($state.params.date) {
					getScheduleForDay(moment($state.params.date, 'YYYY-MM-DD'));
				}
				else {
					getScheduleForDay(moment());
				}

				self.calendar.uiConfig = {
					calendar: {
						editable: true,
						selectable: true,
						selectHelper: true,
						droppable: true,
						contentHeight: 'auto',
						firstDay: 1,
						// stickyHeaderDates:true,
						nextDayThreshold: '00:00:00',
						displayEventTime: false,
						eventOrder: "route_id,order",
						viewRender: function (view, element) {
							element.find('.fc-day-number').each((index, el) => {
								el = angular.element(el);
								el.addClass('fc-day-number-expanded');
								let parent = angular.element(el.parent('.fc-day-top'));
								let dayMoment = moment(parent.data('date'));
								let html = '<div class="clearfix"><span class="fc-day-number-left">' + dayMoment.format('ddd') + '</span><span class="fc-day-number-right">' + dayMoment.format('D') + '</span></div>';
								el.html(html);
							});
						},
						select: function (start, end, jsEvent, view) {
							// Check we've only clicked a single day & return
							if (end.diff(start, 'days') > 1) {
								TGScheduleSvc.showBulkAssignVisitModal(start, end).then(function(result) {
									notify({
										message: 'Updated ' + result + ' visits',
									});
									getScheduleForDay(start);
								});
							}
						},
						dayClick: function (date, jsEvent, view) {
							dayClick(date);
						},
						eventRender: function (event, element) {
							event.startEditable = !event.locked;
							if (event.type === 'activity') {
								event.editable = false;
								event.startEditable = false;
								event.durationEditable = false;
							}
							element.find('.fc-title').html(event.title);
							$compile(element)($scope);
						},
						eventDragStart: function( event, jsEvent, ui, view ) {

						},
						eventClick: function (event, jsEvent, view) {
							if (event.type == 'activity') {
								editActivity(event);
							}
							else {
								if (event.locked) {
									notify({
										message: 'This visit is locked',
										classes: 'error'
									});
									return;
								}
								dayClick(event.start);
								TGScheduleSvc.showMoveVisitModal(event.visitId, event.start)
									.then(function (result) {
										if (result.data.moved) {
											getScheduleForDay(event.start);
										}
										notify({
											message: 'Schedule updated'
										});
										view.calendar.refetchEvents();
									});
							}
						},
						eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
							if (event.type === 'activity') {
								notify({
									message: 'Activities can only be moved from the main calendar',
									classes: 'error'
								});
								revertFunc();
								return;
							}
							if (event.locked) {
								notify({
									message: 'This visit is locked',
									classes: 'error'
								});
								revertFunc();
								return;
							}
							var toDate = angular.copy(event.start);
							TGScheduleSvc.showMoveVisitModal(event.visitId, toDate)
								.then(function (result) {
									if (!result.data.moved) {
										revertFunc();
									}
									else {
										getScheduleForDay(toDate);
									}
									notify({
										message: 'Schedule updated'
									});
									view.calendar.refetchEvents();
								}, function () {
									revertFunc();
								});
						},
						dayRender: function (date, cell) {
							if (angular.isObject(self.selectedDate)) {
								if (date.format('YYYY-MM-DD') === self.selectedDate.format('YYYY-MM-DD')) {
									cell.css("background-color", "#F6FAEE");
								}
							}
						},
						loading: function (bool) {
							// console.log('loading');
						},
						eventAfterAllRender: function (view) {
							// console.log('loaded');
						},
						header: {
							left: 'prev,next today',
							center: 'title',
							right: null
						},
						lang: 'en-GB'
					}


				};

				$scope.allEventSources = {
					bank_holidays: {
						active: true,
						events: function (start, end, timezone, callback) {
							var config = {
								params: {
									start: start.format(ConfigService.config.format.date.amDbDateTime),
									end: end.format(ConfigService.config.format.date.amDbDateTime),
								}
							};
							CalendarSvc.bankHolidays(config.params)
								.then(function (response) {
									events = response.data.events;
									callback(events);
								}, function () {
									console.log('Failed to load bank holidays');
								});
						},
						editable: false,
						overlap: true
					},
					visits: {
						active: true,
						events: function (start, end, timezone, callback) {
							var config = {
								params: {
									schedule: true,
									start: start.format(ConfigService.config.format.date.amDbDateTime),
									end: end.format(ConfigService.config.format.date.amDbDateTime),
									employee: (self.employee) ? self.employee.id : '',
									eventView: self.eventView,
								}
							};

							TGVisitSvc.calendarEvents(config.params)
								.then(function (response) {
									events = response.data.events;
									angular.forEach(events, function (event) {
										let title = event.title;
										event.title = '';
										event.className = 'tg-schedule-calendar-event';
										if (event.isEcom) {
											event.title += '<img class="visit-status-icon" src="../../images/icons/online-job-icon.png">';
											event.className += ' reschedule';
										}
										else {
											if (event.isIncomplete) {
												event.title += '<img class="visit-status-icon" src="../../images/icons/warning-icon.png">';
												event.className += ' reschedule';
											}
											else if (event.isClosed) {
												event.title += '<img class="visit-status-icon" src="../../images/icons/complete-icon.png">';
												event.className += ' complete';
											}
											else {
												event.title += '<img class="visit-status-icon" src="../../images/icons/action-icon.png">';
												event.className += ' open';
											}
											if (event.isLastVisit) {
												event.title += '<img class="visit-status-icon" src="../../images/icons/last-visit-icon.png">';
												event.className += ' last-visit';
											}
											if (event.isInactive) {
												event.title += '<img class="visit-status-icon" src="../../images/icons/last-visit-icon.png">';
												event.className += ' tg-visit-inactive';
											}
										}
										event.title += title;
									});
									callback(events);
								}, function () {
									console.log('Failed to load visit events');
								});
						}
					},
					activity: {
						active: true,
						events: function (start, end, timezone, callback) {
							var config = {
								params: {
									start: start.format(ConfigService.config.format.date.amDbDateTime),
									end: end.format(ConfigService.config.format.date.amDbDateTime),
								}
							};

							ActivitySvc.calendarEvents(config.params)
								.then(function (response) {
									events = response.data.events;
									callback(events);
								}, function () {
									console.log('Failed to load activity events');
								});
						}
					},
					holidays: {
						active: false,
						events: function (start, end, timezone, callback) {
							var config = {
								params: {
									start: start.format(ConfigService.config.format.date.amDbDateTime),
									end: end.format(ConfigService.config.format.date.amDbDateTime),
									activeEmployee: true
								}
							};
							EmployeeHolidaySvc.allEmployeesCalendar(config.params)
								.then(function (response) {
									events = response.data.employee_holidays;
									callback(events);
								}, function () {
									console.log('Failed to load employee holidays calendar');
								});
						}
					}
				};

				fetchEvents();
				loadEmployees(); // for technician filter

			}

			function loadEmployees() {
				var employeeParams = {
					filter: {
						status: true
					}
				};

				EmployeeSvc.index(employeeParams)
					.then(function (response) {
						self.employeeOptions = response.data.employee_collection;
					});
			}

			function setDefaultEventView() {
				var eventView = $window.localStorage['tg_schedule_event_view'];
				if (angular.isUndefined(eventView)) {
					$window.localStorage['tg_schedule_event_view'] = 'name';
					self.eventView = 'name';
				}
				else {
					self.eventView = $window.localStorage['tg_schedule_event_view'];
				}
			}

			function dayClick(date) {
				if (self.selectedDate == null || self.selectedDate.format('DDMMYYYY') != date.format('DDMMYYYY')) {
					self.selectedDate = date;
					getScheduleForDay(date);
				}
			}

			function getScheduleForDay(date) {
				self.selectedDate = date;
				var params = {
					date: date.format('YYYY-MM-DD')
				};
				self.loadingScheduleForDay = true;
				return TGScheduleSvc.byDay(params)
					.then(function (response) {
						self.employees = response.data.employee_collection;
						self.loadingScheduleForDay = false;
						angular.forEach(self.employees, function(employee) {
							angular.extend(employee, {
								employee_minutes: EmployeeSvc.getTGEmployeeVisitDuration(employee.tg_visits)
							});
						});
						// Expand the employee if there is only one returned
						if (self.employees.length == 1) {
							self.employees[0].expanded = true;
						}
					});
			}

			function editVisit(visit, employee = null) {
				TGScheduleSvc.showMoveVisitModal(visit.id, null)
					.then(function (result) {
						angular.extend(visit, result.data.visit);
						uiCalendarConfig.calendars['calendar'].fullCalendar('refetchEvents');
						if (employee) {
							self.methods.calculateTravelTime(employee);
						}
					});
			}

			function fetchEvents() {
				// remove all event sources
				$timeout(function(){
					angular.forEach($scope.allEventSources, function (value) {
						uiCalendarConfig.calendars['calendar'].fullCalendar('removeEventSource', value);
					});
					angular.forEach($scope.allEventSources, function (value) {
						if (value.active === true) {
							uiCalendarConfig.calendars['calendar'].fullCalendar('addEventSource', value);
						}
					});
				},0);
			}

			function addTreatment(visit) {
				TGTreatmentSvc.showJobTreatmentModal(visit.job)
					.then(function (result) {
						var visitTreatment = {
							visit_id: visit.id,
							treatment_id: null,
							completed: null,
							inactive: false,
							treatment_number: 1,
							work_duration_in_mins: result.jobTreatment.treatment_time_in_mins,
							treatment: result.jobTreatment
						};

						visitTreatment.treatment.additional_treatment = true;
						visitTreatment.isNew = true;
						visit.treatments.push(visitTreatment);

						// Save the visit
						TGVisitSvc.save(visit)
							.then(function (response) {
								angular.extend(visit, response.data.visit);
								EmployeeSvc.getTGEmployeeVisitDuration([visit]);
								getScheduleForDay(moment(visit.visit_date));
							}, function (errors) {
								// display an error and remove the new treatment from the list
								notify({
									message: 'Failed to save the treatments: ' + errors[0],
									classes: 'error',
									duration: '0'
								});
								var index = visit.treatments.indexOf(visitTreatment);
								visit.treatments.splice(index, 1);
							});

					});
			}

			function expandAllVisits(employee) {
				angular.forEach(employee.tg_visits, function (visit) {
					visit.expanded = true;
				});
			}

			function collapseAllVisits(employee) {
				angular.forEach(employee.tg_visits, function (visit) {
					visit.expanded = false;
				});
			}

			function moveAllVisitsChecked(employee) {
				angular.forEach(employee.tg_visits, function (visit) {
					if (!visit.locked) {
						visit.selected = !!employee.all_visits_selected;
					}
				});
			}

			function moveAllVisitsClicked(employee) {
				TGScheduleSvc.showMoveMultipleVisitsModal(employee)
					.then(function (result) {
						uiCalendarConfig.calendars['calendar'].fullCalendar('refetchEvents');
					});
			}

			function employeeChanged() {
				uiCalendarConfig.calendars['calendar'].fullCalendar('refetchEvents');
			}

			function printRoute(employee, date) {
				DirectionSvc.printDirections({
					route_id: employee.tg_route.id,
					date: date.format()
				});
			}

			function onRouteClick(employee, date) {
				let manualRoute = {
					origin: employee.starting_location,
					destination: employee.starting_location,
					date: self.selectedDate,
					employee: employee,
					departureTime: new moment('09:00:00', 'HH:mm:ss'),
					waypoints: []
				};

				angular.forEach(employee.tg_visits, (tg_visit) => {
					if (!tg_visit.inactive) {
						manualRoute.waypoints.push({
							id: tg_visit.id,
							latitude:  angular.isObject(tg_visit.job.customer) ? tg_visit.job.site.lat : tg_visit.job.enquiry.lat,
							longitude: angular.isObject(tg_visit.job.customer) ? tg_visit.job.site.lng : tg_visit.job.enquiry.lng,
							postcode: angular.isObject(tg_visit.job.customer) ? tg_visit.job.site.postcode : tg_visit.job.enquiry.postcode,
							label: angular.isObject(tg_visit.job.customer) ? tg_visit.job.customer.label : tg_visit.job.enquiry.display_name,
							is_ecom: tg_visit.job.is_ecom,
							jobDurationSeconds: tg_visit.work_duration_in_mins * 60,
							preferredTimeLabel: tg_visit.job.preferred_appointment_time
						});
					}
				});

				ManualRouteSvc.displayManualRouteModal(manualRoute)
					.then(function (result) {
						self.loadingScheduleForDay = true;
						employee.tg_route.visits = angular.copy(result.manualRoute.waypoints);
						for (let i = 0; i < employee.tg_route.visits.length; i++) {
							employee.tg_route.visits[i].order = i;
						}
						console.info(employee.tg_route);
						TGRouteSvc.save({route: employee.tg_route}).then(() => {
							getScheduleForDay(self.selectedDate).then(() => {
								self.loadingScheduleForDay = false;
								self.loadingScheduleForDay = false;
							});
						});
					});
			}

			function calculateTravelTime(employee) {
				var params = {
					route: employee.tg_route,
					optimise: (employee.tg_route.visits.length <= 18) ? true : false // don't optimise anything over 18 waypoints (google maximum)
				};

				VisitPlannerSvc.calculateTravelTime(params).then(function (response) {
					angular.extend(employee.tg_route, {
						total_travel_time: response.data.total_minutes
					});
					TGRouteSvc.save({route: employee.tg_route});
				}, function(errors) {
					self.errors = errors;
				});

			}

			function showInventoryRequired() {
				if (angular.isDefined(self.selectedDate)) {
					TGScheduleSvc.showInventoryRequiredModal(self.selectedDate, self.employee ? self.employee.id : '')
						.then(function (result) {

						});
				}
			}

			function eventViewUpdated() {
				// console.log(self.eventView);
				// $window.localStorage['tg_schedule_event_view'] = self.eventView;
				// uiCalendarConfig.calendars['calendar'].fullCalendar('refetchEvents');
				fetchEvents();
			}

			function editActivity(event) {
				ActivitySvc.showSaveModal(event.activity)
					.then(function (result) {
						uiCalendarConfig.calendars['calendar'].fullCalendar('refetchEvents');
					});
			}

			function chemicalRecords() {
				$window.open('trugreen/chemical-form-by-date/'+self.selectedDate.format('Y-MM-D'));
			}

			function worksheet() {
				var employeeFilter = (self.employee) ? '/'+self.employee.id : '';
				$window.open('trugreen/worksheet/'+self.selectedDate.format('Y-MM-D')+employeeFilter);
			}

			function preinvoiceAll() {
				TGScheduleSvc.showPreInvoiceAllModal(self.selectedDate, self.employees).then(function(result) {
					notify({
						message: 'Preinvoiced ' + result + ' visit(s)',
					});
					getScheduleForDay(self.selectedDate);
				});
			}

			function showProximityLocatorModal(job, $event) {
				$event.stopPropagation();
				ProximitySvc.showLocatorModal({id: job.licence_id}, job.site.postcode);
			}

			var self = $scope.TGScheduleCtrl = {
				loading: false,
				loadingScheduleForDay: false,
				loadingEvents: false,
				employees: [],
				selectedDate: null,
				eventView: null,
				calendar: {
					uiConfig: null,
					eventSources: []
				},
				methods: {
					init: init,
					addTreatment: addTreatment,
					editVisit: editVisit,
					expandAllVisits: expandAllVisits,
					collapseAllVisits: collapseAllVisits,
					moveAllVisitsChecked: moveAllVisitsChecked,
					moveAllVisitsClicked: moveAllVisitsClicked,
					employeeChanged: employeeChanged,
					printRoute: printRoute,
					onRouteClick: onRouteClick,
					calculateTravelTime: calculateTravelTime,
					eventViewUpdated: eventViewUpdated,
					showInventoryRequired: showInventoryRequired,
					chemicalRecords: chemicalRecords,
					worksheet: worksheet,
					preinvoiceAll: preinvoiceAll,
					showProximityLocatorModal: showProximityLocatorModal,

				}
			}

		});
